$(document).ready(function () {
	let $userBonus = $('.user-bonus'),
		$loader = $userBonus.find('.loader');

	if ($userBonus.length) {
		let route = $userBonus.data('route');
		$.get(route, {}, function (data) {
			$userBonus.find('.balance').html(data.balance || 0);
			$userBonus.find('.currency').html(data.currency?.nameCases?.abbreviation || '');
			$loader.addClass('is-loaded');
		});
	}
});
